import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export const SAVE_SEARCH_LABEL = 'Save as Saved Search';
export const SAVE_SEARCH_DESCRIPTION = 'Saves the full list as a new Saved Search, including its enrichments.';

export default function ChatArtifactSaveSearch({ action, running, busy, onRunAction }) {
  return (
    <Box>
      <Button
        size="small"
        variant="outlined"
        disabled={action.enabled === false || busy}
        aria-busy={running}
        onClick={() => onRunAction?.('save_to_workspace')}
        sx={{ textTransform: 'none' }}
      >
        {running ? 'Saving…' : SAVE_SEARCH_LABEL}
      </Button>
      {action.enabled === false && action.disabled_reason && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {action.disabled_reason}
        </Typography>
      )}
    </Box>
  );
}
